/* ================================================================
   DCL PC-Konfigurator v2 — pc-configurator-v2.js
   Schritte + Pflichtfelder kommen per data-steps aus Liquid/Customizer
   ================================================================ */
(function () {
  'use strict';

  const CONFIG_TYPES = {
    'intel-gaming': { label: 'Intel Gaming PC',  tagPrefix: 'intel', badge: 'INTEL' },
    'amd-gaming':   { label: 'AMD Gaming PC',    tagPrefix: 'amd',   badge: 'AMD'   },
    'intel-office': { label: 'Intel Office PC',  tagPrefix: 'intel', badge: 'INTEL' },
    'amd-office':   { label: 'AMD Office PC',    tagPrefix: 'amd',   badge: 'AMD'   },
    'workstation':  { label: 'Workstation',      tagPrefix: null,    badge: 'WS'    },
  };

  const STEPS_FALLBACK = [
    { key: 'case',    label: 'Geh\u00e4use',        cat: 'Geh\u00e4use',        tag: 'konfig-gehaeuse',  required: false, icon: '\uD83D\uDDA5' },
    { key: 'cpu',     label: 'Prozessor',        cat: 'Prozessor',       tag: 'konfig-cpu',       required: true,  icon: '\u25FC' },
    { key: 'cooler',  label: 'CPU-K\u00fchler',     cat: 'K\u00fchlung',         tag: 'konfig-kuehler',   required: false, icon: '\u2744' },
    { key: 'board',   label: 'Mainboard',        cat: 'Mainboard',       tag: 'konfig-mainboard', required: true,  icon: '\uD83D\uDCCB' },
    { key: 'ram',     label: 'Arbeitsspeicher',  cat: 'Arbeitsspeicher', tag: 'konfig-ram',       required: true,  icon: '\uD83D\uDCBE' },
    { key: 'gpu',     label: 'Grafikkarte',      cat: 'Grafikkarte',     tag: 'konfig-gpu',       required: false, icon: '\uD83C\uDFAE' },
    { key: 'storage', label: 'SSD / Festplatte', cat: 'Speicher',        tag: 'konfig-storage',   required: true,  icon: '\uD83D\uDCBF' },
    { key: 'psu',     label: 'Netzteil',         cat: 'Netzteil',        tag: 'konfig-netzteil',  required: true,  icon: '\u26A1' },
    { key: 'os',      label: 'Betriebssystem',   cat: 'Software',        tag: 'konfig-os',        required: false, icon: '\uD83E\uDE9F' },
  ];

  const urlParams  = new URLSearchParams(window.location.search);
  const activeType = urlParams.get('type') || '';
  const activeConf = CONFIG_TYPES[activeType] || { label: 'PC-Konfigurator', tagPrefix: null, badge: '' };

  let root        = null;
  let STEPS       = [];
  let einbauPreis = 0;
  let einbauVId   = '';
  let selection   = {};
  let cache       = {};
  let toastTimer  = null;

  function boot() {
    root = document.querySelector('.dcl-cfg');
    if (!root) return;
    einbauPreis = parseFloat(root.dataset.einbauPreis) || 0;
    einbauVId   = root.dataset.einbauVariantId || '';
    STEPS = parseSteps();
    buildUI();
    renderSidebar();
    wireButtons();
  }

  function parseSteps() {
    try {
      const raw = root.dataset.steps;
      if (!raw) return STEPS_FALLBACK;
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) && parsed.length ? parsed : STEPS_FALLBACK;
    } catch (e) {
      return STEPS_FALLBACK;
    }
  }

  function buildUI() {
    const container = root.querySelector('.dcl-components');
    if (!container) return;
    container.innerHTML = '';
    let lastCat = null;
    STEPS.forEach(step => {
      if (step.cat !== lastCat) {
        const div = document.createElement('div');
        div.className = 'dcl-components__section-head';
        div.textContent = step.cat;
        container.appendChild(div);
        lastCat = step.cat;
      }
      container.appendChild(buildRow(step));
    });
  }

  function buildRow(step) {
    const row = document.createElement('div');
    row.className = 'dcl-row';
    row.dataset.key = step.key;
    const reqBadge = step.required
      ? '<span class="dcl-row__required">Pflicht</span>'
      : '<span class="dcl-row__optional">Optional</span>';
    const icon = step.icon || '';

    row.innerHTML = `
      <div class="dcl-row__head">
        <div class="dcl-row__label">
          <span class="dcl-row__label-icon">${icon}</span>
          ${step.label}${reqBadge}
        </div>
        <div class="dcl-row__current">
          <span class="dcl-row__current-name is-empty">Bitte w\u00e4hlen \u2026</span>
          <span class="dcl-row__current-price" style="display:none"></span>
        </div>
        <svg class="dcl-row__arrow" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
          <path d="M4 6l4 4 4-4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <div class="dcl-row__body">
        <div class="dcl-row__search">
          <span class="dcl-row__search-icon">\uD83D\uDD0D</span>
          <input type="text" placeholder="${step.label} suchen \u2026" autocomplete="off">
        </div>
        <div class="dcl-product-list">${buildSkeletons(3)}</div>
        ${!step.required ? `<div class="dcl-row__skip"><button type="button" data-key="${step.key}">Diesen Schritt \u00fcberspringen</button></div>` : ''}
      </div>`;

    row.querySelector('.dcl-row__head').addEventListener('click', () => toggleRow(row, step));
    row.querySelector('.dcl-row__skip button')?.addEventListener('click', e => {
      e.stopPropagation();
      delete selection[step.key];
      updateRowDisplay(row, step, null);
      renderSidebar();
      closeRow(row);
    });
    row.querySelector('.dcl-row__search input').addEventListener('input', e => {
      filterProducts(row, e.target.value.trim().toLowerCase());
    });
    return row;
  }

  function toggleRow(row, step) {
    row.classList.contains('is-open') ? closeRow(row) : openRow(row, step);
  }
  function openRow(row, step) {
    root.querySelectorAll('.dcl-row.is-open').forEach(r => { if (r !== row) closeRow(r); });
    row.classList.add('is-open');
    const list = row.querySelector('.dcl-product-list');
    if (!list.dataset.loaded) loadProducts(step, list, row);
    setTimeout(() => row.scrollIntoView({ behavior: 'smooth', block: 'nearest' }), 80);
  }
  function closeRow(row) { row.classList.remove('is-open'); }

  async function loadProducts(step, listEl, row) {
    const prefix   = activeConf.tagPrefix;
    const cacheKey = prefix ? `${step.tag}__${prefix}` : step.tag;
    if (cache[cacheKey]) { renderProductList(cache[cacheKey], listEl, step, row); listEl.dataset.loaded = '1'; return; }
    try {
      let products = [];
      if (prefix) {
        const r = await fetch(`/collections/${prefix}-${step.tag}/products.json?limit=30`);
        if (r.ok) products = (await r.json()).products || [];
      }
      if (!products.length) {
        const r = await fetch(`/collections/${step.tag}/products.json?limit=30`);
        if (r.ok) products = (await r.json()).products || [];
      }
      if (!products.length) {
        const r = await fetch('/products.json?limit=50');
        if (r.ok) {
          const all = (await r.json()).products || [];
          const baseKey = step.tag.replace('konfig-', '');
          products = all.filter(p => {
            const tags = (p.tags || []).map(t => t.toLowerCase());
            if (!tags.some(t => t.includes(baseKey))) return false;
            return prefix ? tags.some(t => t.includes(prefix)) : true;
          });
        }
      }
      cache[cacheKey] = products;
      renderProductList(products, listEl, step, row);
      listEl.dataset.loaded = '1';
    } catch (e) {
      listEl.innerHTML = `<div class="dcl-no-products"><div class="dcl-no-products__icon">\uD83D\uDCE6</div><p>Keine Produkte gefunden.</p><p class="dcl-no-products__hint">Tag: <code>${step.tag}</code></p></div>`;
      listEl.dataset.loaded = '1';
    }
  }

  function renderProductList(products, listEl, step, row) {
    listEl.innerHTML = '';
    if (!products.length) {
      listEl.innerHTML = `<div class="dcl-no-products"><div class="dcl-no-products__icon">\uD83D\uDCE6</div><p>Keine Produkte gefunden.</p><p class="dcl-no-products__hint">Collection <strong>${step.tag}</strong> anlegen.</p></div>`;
      return;
    }
    products.forEach(p => {
      const variantId = p.variants?.[0]?.id || '';
      const price     = parseFloat(p.variants?.[0]?.price) || 0;
      const img       = p.images?.[0]?.src || '';
      const selected  = selection[step.key]?.variantId == variantId;
      const specTags  = (p.tags || []).filter(t => !t.startsWith('konfig-') && t.length < 30).slice(0, 4);
      const opt = document.createElement('div');
      opt.className = `dcl-product-opt${selected ? ' is-selected' : ''}`;
      opt.dataset.variantId = variantId;
      opt.dataset.title     = p.title;
      opt.dataset.price     = price;
      opt.dataset.image     = img;
      opt.dataset.tags      = (p.tags || []).join(',');
      opt.innerHTML = `
        ${img ? `<img class="dcl-product-opt__img" src="${img}" alt="${esc(p.title)}" loading="lazy">` : `<div class="dcl-product-opt__img-placeholder">${step.icon || ''}</div>`}
        <div class="dcl-product-opt__info">
          <div class="dcl-product-opt__name">${p.title}</div>
          ${specTags.length ? `<div class="dcl-product-opt__tags">${specTags.map(t => `<span class="dcl-product-opt__tag">${t}</span>`).join('')}</div>` : ''}
        </div>
        <div class="dcl-product-opt__price">${fmt(price)}</div>`;
      opt.addEventListener('click', () => selectProduct(opt, step, row, { variantId, title: p.title, price, image: img, tags: specTags }));
      listEl.appendChild(opt);
    });
  }

  function selectProduct(opt, step, row, data) {
    if (selection[step.key]?.variantId == data.variantId) {
      delete selection[step.key];
      opt.classList.remove('is-selected');
      updateRowDisplay(row, step, null);
      removeDetailBox(row);
      renderSidebar();
      return;
    }
    row.querySelectorAll('.dcl-product-opt').forEach(o => o.classList.remove('is-selected'));
    opt.classList.add('is-selected');
    selection[step.key] = { ...data, key: step.key, label: step.label, icon: step.icon || '' };
    updateRowDisplay(row, step, data);
    showDetailBox(row, step, data);
    renderSidebar();
    showToast(`\u2713 ${data.title.substring(0, 38)} ausgew\u00e4hlt`);
  }

  function updateRowDisplay(row, step, data) {
    const nameEl  = row.querySelector('.dcl-row__current-name');
    const priceEl = row.querySelector('.dcl-row__current-price');
    if (data) {
      nameEl.textContent = data.title; nameEl.classList.remove('is-empty');
      priceEl.textContent = fmt(data.price); priceEl.style.display = '';
    } else {
      nameEl.textContent = 'Bitte w\u00e4hlen \u2026'; nameEl.classList.add('is-empty');
      priceEl.style.display = 'none';
    }
  }

  function showDetailBox(row, step, data) {
    removeDetailBox(row);
    const box = document.createElement('div');
    box.className = 'dcl-detail';
    const specRows = (data.tags || []).map(t => `<div class="dcl-detail__spec"><span class="dcl-detail__spec-val">${t}</span></div>`).join('');
    box.innerHTML = `
      <div class="dcl-detail__inner">
        <div class="dcl-detail__img-wrap">
          ${data.image ? `<img class="dcl-detail__img" src="${data.image}" alt="${esc(data.title)}">` : `<div class="dcl-detail__img-placeholder">${step.icon || ''}</div>`}
        </div>
        <div class="dcl-detail__content">
          <div class="dcl-detail__name">${data.title}</div>
          ${specRows ? `<div class="dcl-detail__specs">${specRows}</div>` : ''}
        </div>
      </div>
      <div class="dcl-detail__footer">
        <span class="dcl-detail__price">${fmt(data.price)}</span>
        <button type="button" class="dcl-detail__deselect">Auswahl entfernen \u2715</button>
      </div>`;
    box.querySelector('.dcl-detail__deselect').addEventListener('click', () => {
      delete selection[step.key];
      row.querySelectorAll('.dcl-product-opt').forEach(o => o.classList.remove('is-selected'));
      updateRowDisplay(row, step, null);
      removeDetailBox(row);
      renderSidebar();
    });
    row.querySelector('.dcl-row__body').appendChild(box);
  }

  function removeDetailBox(row) { row.querySelector('.dcl-detail')?.remove(); }

  function filterProducts(row, query) {
    row.querySelectorAll('.dcl-product-opt').forEach(opt => {
      const match = !query || (opt.dataset.title || '').toLowerCase().includes(query) || (opt.dataset.tags || '').toLowerCase().includes(query);
      opt.style.display = match ? '' : 'none';
    });
  }

  function renderSidebar() {
    const sidebar      = root.querySelector('.dcl-sidebar__items');
    const countEl      = root.querySelector('.dcl-sidebar__count');
    const barEl        = root.querySelector('.dcl-sidebar__progress-bar');
    const partsTotalEl = root.querySelector('#dcl-parts-total');
    const grandTotalEl = root.querySelector('#dcl-grand-total');
    const cartBtn      = root.querySelector('#dcl-btn-cart');
    const emailBtn     = root.querySelector('#dcl-btn-email');
    const pdfBtn       = root.querySelector('#dcl-btn-pdf');
    const items        = Object.values(selection);
    const partsTotal   = items.reduce((s, i) => s + (i.price || 0), 0);
    const grand        = partsTotal + einbauPreis;
    const progress     = STEPS.length > 0 ? Math.round((items.length / STEPS.length) * 100) : 0;
    if (countEl)      countEl.textContent     = items.length;
    if (barEl)        barEl.style.width        = progress + '%';
    if (partsTotalEl) partsTotalEl.textContent = fmt(partsTotal);
    if (grandTotalEl) grandTotalEl.textContent = fmt(grand);
    if (cartBtn)      cartBtn.disabled         = items.length === 0;
    if (emailBtn)     emailBtn.disabled        = items.length === 0;
    if (pdfBtn)       pdfBtn.disabled          = items.length === 0;
    if (!sidebar) return;
    if (!items.length) { sidebar.innerHTML = '<li class="dcl-sidebar__empty">Noch keine Komponenten gew\u00e4hlt.</li>'; return; }
    sidebar.innerHTML = items.map(it => `
      <li class="dcl-sidebar__item">
        <span class="dcl-sidebar__item-icon">${it.icon || ''}</span>
        <div class="dcl-sidebar__item-info">
          <div class="dcl-sidebar__item-cat">${it.label}</div>
          <div class="dcl-sidebar__item-name">${it.title}</div>
        </div>
        <span class="dcl-sidebar__item-price">${fmt(it.price)}</span>
      </li>`).join('');
  }

  function wireButtons() {
    root.querySelector('#dcl-btn-cart')?.addEventListener('click',  addAllToCart);
    root.querySelector('#dcl-btn-email')?.addEventListener('click', openEmailModal);
    root.querySelector('#dcl-btn-pdf')?.addEventListener('click',   exportPDF);
    root.querySelector('#dcl-btn-reset')?.addEventListener('click', () => {
      if (!confirm('Konfiguration zur\u00fccksetzen?')) return;
      selection = {}; cache = {}; buildUI(); renderSidebar();
      showToast('\u21BA Konfiguration zur\u00fcckgesetzt.');
    });
    document.getElementById('dcl-modal-close')?.addEventListener('click',  closeEmailModal);
    document.getElementById('dcl-modal-cancel')?.addEventListener('click', closeEmailModal);
    document.querySelector('.dcl-modal-bg')?.addEventListener('click', e => {
      if (e.target.classList.contains('dcl-modal-bg')) closeEmailModal();
    });
    document.getElementById('dcl-modal-send')?.addEventListener('click', sendEmail);
  }

  async function addAllToCart() {
    const allSelected = Object.values(selection);

    if (!allSelected.length) {
      showToast('\u26A0\uFE0F Bitte zuerst Komponenten ausw\u00e4hlen.');
      return;
    }

    // Varianten-IDs validieren
    const items = allSelected.filter(i => {
      const vid = parseInt(i.variantId);
      return !isNaN(vid) && vid > 0;
    });

    if (!items.length) {
      showToast('\u26A0\uFE0F Keine g\u00fcltigen Varianten. Shopify-Produkte pr\u00fcfen (F12 Konsole).');
      console.warn('[DCL Konfigurator] Auswahl ohne variantId:', allSelected);
      return;
    }

    const btn = root.querySelector('#dcl-btn-cart');
    if (btn) { btn.disabled = true; btn.textContent = '\u23F3 Wird hinzugef\u00fcgt \u2026'; }

    const cartItems = items.map(it => ({
      id: parseInt(it.variantId),
      quantity: 1,
      properties: { 'Konfiguration': it.label }
    }));

    if (einbauVId && parseInt(einbauVId) > 0 && einbauPreis > 0) {
      cartItems.push({ id: parseInt(einbauVId), quantity: 1, properties: { 'Konfiguration': 'Einbau & Montage' } });
    }

    console.log('[DCL Konfigurator] cart/add.js payload:', cartItems);

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: cartItems })
      });

      if (!res.ok) {
        const errText = await res.text();
        console.error('[DCL Konfigurator] cart Fehler:', res.status, errText);
        throw new Error(errText);
      }

      showToast('\uD83D\uDED2 Alle Komponenten wurden hinzugef\u00fcgt!');
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      setTimeout(() => { window.location.href = '/cart'; }, 1400);
    } catch (e) {
      console.error('[DCL Konfigurator] addAllToCart Fehler:', e);
      showToast('\u274C Fehler. Details in der Konsole (F12).');
      if (btn) { btn.disabled = false; btn.innerHTML = '\uD83D\uDED2 In den Warenkorb'; }
    }
  }

  function openEmailModal()  { root.querySelector('.dcl-modal-bg')?.classList.add('is-open'); }
  function closeEmailModal() { root.querySelector('.dcl-modal-bg')?.classList.remove('is-open'); }

  async function sendEmail() {
    const name  = document.getElementById('dcl-email-name')?.value.trim();
    const email = document.getElementById('dcl-email-addr')?.value.trim();
    const phone = document.getElementById('dcl-email-phone')?.value.trim();
    const msg   = document.getElementById('dcl-email-msg')?.value.trim();
    if (!name || !email) { showToast('\u26A0\uFE0F Bitte Name und E-Mail ausf\u00fcllen.'); return; }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { showToast('\u26A0\uFE0F Ung\u00fcltige E-Mail.'); return; }
    const items = Object.values(selection);
    const partsTotal = items.reduce((s, i) => s + i.price, 0);
    const grand = partsTotal + einbauPreis;
    const lines = STEPS.map(s => { const sel = selection[s.key]; return sel ? `${s.icon||''} ${s.label}: ${sel.title} (${fmt(sel.price)})` : `${s.icon||''} ${s.label}: \u2013`; }).join('\n');
    const bodyText = [`Neue PC-Konfigurationsanfrage von ${name}`, `Typ: ${activeConf.label}`, '', 'Konfiguration:', lines, einbauPreis > 0 ? `\uD83D\uDD27 Einbau & Montage: ${fmt(einbauPreis)}` : '', '', `Teile gesamt: ${fmt(partsTotal)}`, `Gesamtpreis: ${fmt(grand)}`, '', `Name: ${name}`, `E-Mail: ${email}`, phone ? `Tel: ${phone}` : '', '', `Anmerkungen: ${msg || '\u2013'}`].join('\n');
    const fd = new FormData();
    fd.append('form_type', 'contact'); fd.append('utf8', '\u2713');
    fd.append('contact[name]', name); fd.append('contact[email]', email);
    fd.append('contact[phone]', phone || ''); fd.append('contact[body]', bodyText);
    const sendBtn = document.getElementById('dcl-modal-send');
    if (sendBtn) { sendBtn.disabled = true; sendBtn.textContent = '\u23F3 Senden \u2026'; }
    try {
      const res = await fetch('/contact', { method: 'POST', body: fd });
      if (res.ok || res.redirected) { showToast('\uD83D\uDCE7 Anfrage gesendet!'); closeEmailModal(); }
      else throw new Error();
    } catch {
      const sub = encodeURIComponent(`PC-Konfiguration \u2013 ${activeConf.label}`);
      window.location.href = `mailto:info@dercomputerladen.de?subject=${sub}&body=${encodeURIComponent(bodyText)}`;
      if (sendBtn) { sendBtn.disabled = false; sendBtn.textContent = '\uD83D\uDCE7 Absenden'; }
    }
  }

  function exportPDF() {
    const items = Object.values(selection);
    const partsTotal = items.reduce((s, i) => s + i.price, 0);
    const grand = partsTotal + einbauPreis;
    const date = new Date().toLocaleDateString('de-DE');
    const rows = STEPS.map(s => { const sel = selection[s.key]; return `<tr><td style="padding:8px 12px;border-bottom:1px solid #eee;color:#666;font-size:13px">${s.icon||''} ${s.label}</td><td style="padding:8px 12px;border-bottom:1px solid #eee;font-size:13px">${sel ? sel.title : '<em style="color:#bbb">\u2013</em>'}</td><td style="padding:8px 12px;border-bottom:1px solid #eee;font-size:13px;text-align:right;font-weight:700;color:#f47920">${sel ? fmt(sel.price) : ''}</td></tr>`; }).join('');
    const einbauRow = einbauPreis > 0 ? `<tr style="background:#fff8f3"><td style="padding:8px 12px;color:#f47920;font-size:13px">\uD83D\uDD27 Einbau & Montage</td><td style="padding:8px 12px;font-size:13px">Professioneller Einbau</td><td style="padding:8px 12px;text-align:right;font-weight:700;color:#f47920">${fmt(einbauPreis)}</td></tr>` : '';
    const html = `<!DOCTYPE html><html lang="de"><head><meta charset="UTF-8"><title>PC-Konfiguration</title><style>*{box-sizing:border-box;margin:0;padding:0}body{font-family:sans-serif;color:#1a2540;padding:40px}.hd{display:flex;justify-content:space-between;margin-bottom:24px;padding-bottom:14px;border-bottom:3px solid #0a1628}.logo{font-size:22px;font-weight:800}.logo span{color:#f47920}.meta{text-align:right;font-size:11px;color:#7a8599}h1{font-size:17px;font-weight:700;margin-bottom:12px;color:#0a1628}table{width:100%;border-collapse:collapse}th{background:#0a1628;color:#fff;font-size:11px;padding:9px 12px;text-align:left}th:last-child{text-align:right}.tot td{border-top:2px solid #0a1628;font-size:14px;font-weight:800;padding:10px 12px}.sub td{background:#f5f6f8;font-size:12px;color:#6b7a94;padding:7px 12px}.ft{margin-top:32px;font-size:10px;color:#aab;text-align:center}@media print{body{padding:18px}}</style></head><body><div class="hd"><div class="logo">der<span>computer</span>laden</div><div class="meta">PC-Konfiguration<br>${activeConf.label}<br>${date}</div></div><h1>${activeConf.label}</h1><table><thead><tr><th>Komponente</th><th>Produkt</th><th style="text-align:right">Preis</th></tr></thead><tbody>${rows}${einbauRow}</tbody><tfoot><tr class="sub"><td colspan="2">Teile gesamt</td><td style="text-align:right">${fmt(partsTotal)}</td></tr><tr class="tot"><td colspan="2">${einbauPreis > 0 ? 'Gesamtpreis inkl. Einbau' : 'Gesamtpreis'}</td><td style="text-align:right">${fmt(grand)}</td></tr></tfoot></table><div class="ft">dercomputerladen \u2013 Wei\u00dferitzstra\u00dfe 3, 01067 Dresden | Oschatz \u2013 www.dercomputerladen.de</div></body></html>`;
    const w = window.open('', '_blank');
    if (w) { w.document.write(html); w.document.close(); setTimeout(() => w.print(), 600); }
  }

  function buildSkeletons(n) { return Array.from({ length: n }, () => `<div class="dcl-skeleton-row" style="margin-bottom:4px"></div>`).join(''); }
  function fmt(p) { return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(parseFloat(p) || 0); }
  function esc(s) { return String(s || '').replace(/"/g, '&quot;').replace(/</g, '&lt;'); }
  function showToast(msg) {
    let t = document.querySelector('.dcl-toast');
    if (!t) { t = document.createElement('div'); t.className = 'dcl-toast'; document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('is-on');
    clearTimeout(toastTimer); toastTimer = setTimeout(() => t.classList.remove('is-on'), 3200);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
